import { formatISODatePart } from '@flex-packages/date';
import { useCallback } from 'react';

const useFormatISODatePart = ({ locale }) => {
  return useCallback(
    (params) => {
      const { presetName, isoDatePart } = params;
      return formatISODatePart({
        presetName,
        isoDatePart,
        locale
      });
    },
    [locale]
  );
};

export { useFormatISODatePart };
//# sourceMappingURL=useFormatISODatePartV2.mjs.map
